import { push } from "redux-first-history";
import { useDispatch, useSelector } from "react-redux";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import BallotIcon from "@material-ui/icons/Ballot";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import React from "react";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import StarIcon from "@material-ui/icons/Star";

import MenuItem, { NestedMenuItem } from "./menuItem";

const data = [
  {
    name: "Member",
    path: "member",
    icon: <AccountBoxIcon />,
  },
  {
    name: "Create New Order",
    path: "create-order",
    icon: <ShoppingCartIcon />,
  },
  {
    name: "Payment",
    path: "payment",
    icon: <LocalAtmIcon />,
  },
  {
    name: "Promotion",
    icon: <StarIcon />,
    submenu: [
      {
        name: "Medicine",
        path: "medicine",
      },
      {
        name: "Supply",
        path: "supply",
      },
    ],
  },
  {
    name: "Bundle",
    path: "bundle",
    icon: <BallotIcon />,
  },
];

function Menu() {
  const dispatch = useDispatch();
  const historyURL = useSelector((state) => state.router.location.pathname);
  // history path
  const historyRoot = historyURL.split("/")[1];

  // change route
  const onChangeRoute = (path) => () => {
    dispatch(push("/" + path));
  };

  return (
    <div>
      {data.map(({ name, path, submenu, icon }) => {
        // if submenu return nested
        if (submenu) {
          return (
            <NestedMenuItem
              key={name}
              title={name}
              submenu={submenu}
              historyRoot={historyRoot}
              onChangeRoute={(path) => dispatch(push("/" + path))}
              icon={icon}
            />
          );
        }
        return (
          <MenuItem
            key={name}
            title={name}
            active={path === historyRoot}
            onClick={onChangeRoute(path)}
            icon={icon}
          />
        );
      })}
    </div>
  );
}

export default Menu;
